import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
import LoadMoreProjects from '../components/LoadMoreProjects'
import BranchFilter from './BranchFilter'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

    constructor (props) {
        super(props)
        this.state = {
            projects: [],
            count: 4,
            offset: 0,
            currentBranch: '',
            totalAmountProjects: null,
            loadedAllProjects: false,
            isLoading: true,
            error: false,
        }

        this.handleLoadMore = this.handleLoadMore.bind(this)
        this.handleBranchChoice = this.handleBranchChoice.bind(this)
    }

    componentDidMount () {

        // check if href hash exists and is an integer
        if (location.hash &&
            Number.isInteger(parseInt(location.hash.substr(1)))) {

            this.setState({
                currentBranch: location.hash.substr(1),
            }, this.fetchProjects)

        } else {
            this.fetchProjects()
        }
    }

    fetchProjects () {
        this.setState({ isLoading: true })

        let promises = ProjectsAPI.all(this.state)

        Promise.all(promises)
        .then(results => {
            // flatten results into one array
            let data = [].concat.apply([], results)

            // sort data by date
            data.sort(this.latestFirst)

            // get the first few projects
            let limitedData = data.slice(0, this.state.count)

            window.setTimeout(() => {
                this.setState({
                    projects: limitedData,
                    loadedAllProjects: false,
                    isLoading: false,
                })
                this.verifyLoadedAllPosts()
            }, 500)
        })
        .catch(error => {
            this.setState({
                error: true,
                isLoading: false,
            })
        })
    }

    verifyLoadedAllPosts () {
        if (this.state.totalAmountProjects == this.state.projects.length) {
            return this.setState({
                loadedAllProjects: true,
            })
        }

        return false
    }

    handleLoadMore () {
        this.setState((prevState) => {
            return {
                offset: prevState.offset + this.state.count,
            }
        }, this.fetchProjects)
    }

    handleBranchChoice (value) {
        this.setState(() => {
            return {
                currentBranch: value,
                projects: [],
                offset: 0,
            }
        }, this.fetchProjects)
    }

    render () {
        return (
            <div className="c-projects-app">
                <div className="title-branches">
                    <h2 className="c-recent-projects__subtitle">Referenties</h2>

                    <BranchFilter
                        currentBranch={this.state.currentBranch}
                        onSelectBranch={this.handleBranchChoice}
                        language={this.props.language}
                        slugs={this.props.branch_slugs}
                    />
                </div>

                <Projects
                    projects={this.state.projects}
                    loading={this.state.isLoading}
                    error={this.state.error}
                    language={this.props.language}
                />

            </div>
        )
    }

    latestFirst(a,b) {
        if (a.date > b.date)
            return -1;
        if (a.date < b.date)
            return 1;
        return 0;
    }
}

export default App

// WEBPACK FOOTER //
// ./src/js/projects/containers/App.js
